import React from 'react'
import { Helmet } from 'react-helmet-async'

type SEOTagsProps = {
  title?: string
  description?: string
  keywords?: string
  imgUrl?: string
}

export const SEOTags: React.FC<SEOTagsProps> = ({
  title,
  description,
  keywords,
  imgUrl,
}) => {
  const titleText = title ? `${title} | Premier Lacrosse League` : 'Premier Lacrosse League'
  const desc =
    description ??
    'The PLL is a professional lacrosse league with the best players in the world. SBJ’s Breakthrough Sport of the Year in 2020.'
  const keywordsText = `${keywords} PLL, pro lacrosse, lacrosse, professional lacrosse, lacrosse league`
  const lnk = window?.location?.href ?? 'https://premierlacrosseleague.com'
  const image =
    imgUrl ??
    `https://premierlacrosseleague.com/wp-content/uploads/2019/03/PLL__Square_Logo_Social.png`

  return (
    <Helmet>
      <title>{titleText}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={keywordsText} />

      <meta property="og:url" content={lnk} />
      <meta property="og:image" content={image} />
      <meta property="og:description" content={desc} />
      <meta property="og:title" content={titleText} />
      <meta property="og:site_name" content="Premier Lacrosse League" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content={lnk} />
      <meta name="twitter:title" content={titleText} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image}></meta>
    </Helmet>
  )
}
